import { render } from "./SendMes.vue?vue&type=template&id=09fa3e86&scoped=true"
import script from "./SendMes.vue?vue&type=script&lang=js"
export * from "./SendMes.vue?vue&type=script&lang=js"

import "./SendMes.vue?vue&type=style&index=0&id=09fa3e86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fa3e86"]])

export default __exports__